import Box from '@mui/material/Box'
import Skeleton from '@mui/material/Skeleton'
import {
  SP_DETAIL_AVATAR_SIZE_PX,
  SP_DETAIL_MODAL_BORDER,
  SP_DETAIL_PADDING_X_PX,
  SP_DETAIL_STAT_TILE_GAP_PX,
  SP_DETAIL_STAT_TILE_HEIGHT_PX,
  SP_DETAIL_STAT_TILE_RADIUS_PX,
} from '../lib/signal-provider-detail-layout'

export function SignalProviderDetailModalSkeleton() {
  return (
    <Box
      sx={{ px: `${SP_DETAIL_PADDING_X_PX}px`, pb: '20px', pt: '16px' }}
      data-testid="signal-provider-detail-modal-skeleton"
      aria-busy
      aria-label="Loading signal provider details"
    >
      <Box
        sx={{
          display: 'flex',
          gap: '12px',
          alignItems: 'flex-start',
          pb: '14px',
          mb: '18px',
          borderBottom: `1px solid ${SP_DETAIL_MODAL_BORDER}`,
        }}
      >
        <Skeleton variant="circular" width={SP_DETAIL_AVATAR_SIZE_PX} height={SP_DETAIL_AVATAR_SIZE_PX} />
        <Box sx={{ flex: 1, minWidth: 0 }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
            <Skeleton variant="text" width={168} height={24} />
            <Skeleton variant="rounded" width={64} height={22} sx={{ borderRadius: '10px' }} />
          </Box>
          <Skeleton variant="text" width={260} height={22} sx={{ mt: '2px' }} />
        </Box>
      </Box>

      <Box sx={{ display: 'flex', gap: `${SP_DETAIL_STAT_TILE_GAP_PX}px`, mb: '16px' }}>
        {[1, 2, 3, 4].map((i) => (
          <Skeleton
            key={i}
            variant="rounded"
            sx={{
              flex: '1 1 0',
              height: SP_DETAIL_STAT_TILE_HEIGHT_PX,
              borderRadius: `${SP_DETAIL_STAT_TILE_RADIUS_PX}px`,
            }}
          />
        ))}
      </Box>

      <Skeleton variant="text" width={168} height={28} sx={{ mb: '10px' }} />

      <Skeleton variant="rounded" height={230} sx={{ borderRadius: '10px' }} />

      <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: '20px' }}>
        <Skeleton variant="rounded" width={72} height={40} sx={{ borderRadius: '12px' }} />
      </Box>
    </Box>
  )
}
